import { ShouldDisplayMeasurementFusdrBadgeProps } from 'models/measurement';
import { ShouldDisplayPatientFusdrBadgeProps } from 'models/patientMedicalEvent';
import { EicStatus } from 'models/profile';
import { showUsaFeature } from 'utils/app';

export enum PatientDetailsTabs {
  Overview = 'overview',
  Reports = 'reports',
  Info = 'info',
  Rules = 'rules',
}

export enum PatientOverviewTab {
  Heartrate = 'heartrate',
  Bloodpressure = 'bloodpressure',
  Weight = 'weight',
}

export const shouldDisplayPatientFusdrBadge = ({
  eicInfo,
  fdaAllowedDeviceModels,
  phoneModel,
}: ShouldDisplayPatientFusdrBadgeProps) => {
  if (!showUsaFeature) return false;
  if (fdaAllowedDeviceModels === undefined || phoneModel === undefined) return false;

  return eicInfo?.status === EicStatus.Approved && !fdaAllowedDeviceModels?.some((phone) => phone.model === phoneModel);
};

export const shouldDisplayMeasurementFusdrBadge = ({ measurementTags }: ShouldDisplayMeasurementFusdrBadgeProps) => {
  if (!showUsaFeature) return false;
  return measurementTags?.includes('incompatible_device_eic_given');
};
